var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.desktopOptimized
    ? _c("FloatingNotification", {
        ref: "floatingNotification",
        class: [
          "desktop-optimized-notification",
          _vm.desktopOptimized && "is-available"
        ],
        attrs: {
          messageText:
            "Screen is not optimized for use on screen sizes smaller than desktop.",
          state: "warning",
          iconClassName: "icon-warning-01",
          expanded: true,
          disabled: _vm.disabled
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }